import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue";
import { getItemByProp } from '@/utils/tools';
import { validatorNonNull } from '@/utils/validate';
import { useI18n } from 'vue-i18n';
export default /*#__PURE__*/_defineComponent({
  __name: 'TheAction',
  props: {
    modelValue: {
      type: Object,
      default: {
        name: '',
        sequence: '',
        status: 'valid',
        type: 'movie',
        adultClassification: '',
        description: ''
      }
    }
  },

  setup(__props, {
    expose
  }) {
    const props = __props;
    const {
      t
    } = useI18n();
    const ChannelStatus = [{
      label: '有效',
      value: 'valid'
    }, {
      label: '无效',
      value: 'invalid'
    }];
    const FilmType = [{
      label: '单片',
      value: 'movie'
    }, {
      label: '剧集',
      value: 'tv_series'
    }, {
      label: '系列片',
      value: 'video_series'
    }];
    const langOptions = JSON.parse(sessionStorage.getItem('themeLangOptions'));
    const formRef = ref(null);
    const searchSelect = ref(null);
    const formConfig = reactive({
      formList: [[{
        label: '名称',
        prop: 'name',
        widgetType: 'input',
        maxlength: 50,
        rules: [{
          required: true,
          validator: (rule, value, callback) => validatorNonNull(rule, value, callback, '请输入名称'),
          trigger: 'blur'
        }]
      }, {
        label: '排序',
        prop: 'sequence',
        widgetType: 'Select',
        filterable: true,
        itemSlot: true,
        id: 'sequence',
        list: [{
          label: t('最后'),
          value: 999
        }],
        rules: [{
          required: true,
          trigger: 'change',
          message: '请选择排序'
        }]
      }], [{
        label: '状态',
        prop: 'status',
        widgetType: 'Select',
        list: ChannelStatus,
        translation: true,
        rules: [{
          required: true,
          message: t('请选择'),
          trigger: 'blur'
        }]
      }, {
        label: '类型',
        prop: 'type',
        widgetType: 'Select',
        list: FilmType,
        translation: true
      }], [{
        label: '语言',
        prop: 'sourceLanguage',
        widgetType: 'Select',
        list: langOptions,
        labelKey: 'name',
        valueKey: 'code'
      }, // {
      //   label: '成人分类', prop: 'adult', widgetType: 'Select', list: [
      //     { label: '是', value: 18 },
      //     { label: '否', value: 0 },
      //   ],
      //   translation: true,
      // },
      {
        label: '描述',
        prop: 'description',
        widgetType: 'textarea',
        colspan: 3,
        required: false,
        maxlength: 100,
        showWordLimit: true,
        autosize: true
      }]]
    }); // 向外暴露修改排序下拉函数 最后的value值

    const setLastSortNum = (num, time) => {
      const item = getItemByProp(formConfig.formList, 'sequence');
      let selectLists = [{
        label: t('最后'),
        value: String(num)
      }];

      for (let i = 1; i < time; i++) {
        selectLists.push({
          label: String(i),
          value: i
        });
      }

      ;
      item.list = selectLists;
    };

    expose({
      formRef,
      setLastSortNum,
      formConfig
    });

    const filterInputValue = e => {
      const reg = /[^(\d)]/g;

      if (reg.test(searchSelect.value[0].selectedLabel) || searchSelect.value[0].selectedLabel == '' || formConfig.formList[0][1].list.length == 1) {
        searchSelect.value[0].blur();
      } else {
        if (searchSelect.value[0].selectedLabel >= formConfig.formList[0][1].list[formConfig.formList[0][1].list.length - 1].value) {
          searchSelect.value[0].selectedLabel = String(formConfig.formList[0][1].list[formConfig.formList[0][1].list.length - 1].value);
          setTimeout(() => {
            props.modelValue.sequence = formConfig.formList[0][1].list[formConfig.formList[0][1].list.length - 1].value;
          }, 100);
        } else {
          setTimeout(() => {
            props.modelValue.sequence = Number(searchSelect.value[0].selectedLabel);
          }, 100);
        }
      }
    };

    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_FormItem = _resolveComponent("FormItem");

      const _component_FormTable = _resolveComponent("FormTable");

      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_FormTable, {
        formData: __props.modelValue,
        ref_key: "formRef",
        ref: formRef,
        col: ['15%', '35%', '15%', '35%']
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formConfig.formList, item => {
          return _openBlock(), _createBlock(_component_FormItem, {
            "form-item": item,
            "form-data": __props.modelValue
          }, {
            itemSlot: _withCtx(scope => [_createVNode(_component_el_select, {
              style: {
                "width": "100%"
              },
              id: "sequence",
              modelValue: __props.modelValue.sequence,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => __props.modelValue.sequence = $event),
              filterable: "",
              onInput: filterInputValue,
              ref_for: true,
              ref_key: "searchSelect",
              ref: searchSelect
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formConfig.formList[0][1].list, (item, index) => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: index,
                  label: item.label,
                  value: item.value
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 2
            }, 1032, ["modelValue"])]),
            _: 2
          }, 1032, ["form-item", "form-data"]);
        }), 256))]),
        _: 1
      }, 8, ["formData"])]);
    };
  }

});